export enum EComplaintTemplateDirection {    
    ToCargoTransporter,
    ToShipper
}